import type { PropsWithChildren } from 'react';
import { createReadableClass } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';
import { Text } from './text';

export function PaymentErrorMessage({ children }: PropsWithChildren) {
  return (
    <Text
      error
      className={createReadableClass({
        component: CLASS_COMPONENT,
        element: 'payment-error-message'
      })}
    >
      {children}
    </Text>
  );
}
